import { defineMessages } from 'react-intl';

export default defineMessages({
    AddSpousePopupTitle: {
        id: 'ml.common.views.ml-spouse-dialog.Add spouse',
        defaultMessage: 'Add spouse'
    },
    NotALicensedDriver: {
        id: 'ml.common.views.ml-spouse-dialog.This person is not a licensed driver and will be listed as a household member',
        defaultMessage: 'This person is not a licensed driver or is abroad or in the military and will be listed as a household member.'
    },
    AMPNotALicensedDriver: {
        id: 'ml.common.views.ml-spouse-dialog.AMP.This person is not a licensed driver and will be listed as a household member',
        defaultMessage: 'This person is not a licensed driver and will be listed as a household member.'
    },
    HouseholdHelpText: {
        id: 'ml.common.views.ml-spouse-dialog.Why do they have to be added?',
        defaultMessage: 'Why do they have to be added?'
    },
    IsDriverNotLicensed: {
        id: 'ml.common.views.ml-spouse-dialog.Is driver not licensed',
        defaultMessage: 'Is driver not licensed?'
    },
    IsAbroadOrMilitary: {
        id: 'ml.common.views.ml-spouse-dialog.or abroad or in the military',
        defaultMessage: 'or abroad or in the military?'
    },
    WhyDoYouNeedThis: {
        id: 'ml.common.views.ml-spouse-dialog.why do you need this?',
        defaultMessage: 'Why do you need this?'
    },
    WeNeedThisInformationToProvideYouAnAccurateQuote: {
        id: 'ml.common.views.ml-spouse-dialog.we need this information to provide you an accurate quote.',
        defaultMessage: 'We need this information to provide you an accurate quote.'
    }
});
